import React from 'react'
// import { createGlobalStyle } from 'styled-components/macro'
import styled from '@emotion/styled'
import { CssBaseline } from '@mui/material'

// const GlobalStyle = createGlobalStyle`
//   html,
//   body,
//   #root {
//     height: 100%;
//   }
//   body {
//     background: ${(props) => props.theme.palette.background.default};
//   }
// `

const Root = styled('div')({
  maxwidth: "520px",
  // margin: 0 auto,
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  minheight: "100%"
})

function Auth({ children }) {
  return (
    <Root>
      <CssBaseline />
      {/* <GlobalStyle /> */}
      {children}
    </Root>
  )
}

export default Auth
